import axios from 'axios';
import {history,} from '../store';
import { recordEvent } from '../utils/analyticsEvents';
import CommonConstants from '../utils/CommonConstants';
const apiUrl = CommonConstants.Actions.api;

export function checkOut(token,chkItemArray,insurance,shipment_location_details, warehouse_id, scProtect, itemflags, offsizeItem){
	var air = {};
	var sea = {};
  let airDangerous = [];
  let seaDangerous = [];


		if (chkItemArray.air && chkItemArray.sea == null) {
			air = {
				items : chkItemArray.air,
			}
		}
		if(chkItemArray.sea && chkItemArray.air == null){
			sea  = {
				items : chkItemArray.sea,
			}
		}
		if(chkItemArray.sea && chkItemArray.air){
			air = {
				items : chkItemArray.air,
			}
			sea  = {
				items : chkItemArray.sea,
			}
		}
		if (itemflags) {
			airDangerous = itemflags.airDangerous;
			seaDangerous = itemflags.seaDangerous;
		}

		const payload = {
			token,
			air,sea,
			"insurance":insurance,
			shipment_location_details,
			warehouse_id,
			}
   
		if (scProtect) {
			payload.sc_protect = scProtect;
		}
	return function(dispatch){
		dispatch({type: 'SC_PROTECT_UPDATING'});
		axios.post(apiUrl+'checkout/shipment', payload).then((response) => {
		dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,});
		dispatch({type: 'SC_PROTECT_UPDATED'});
		if (offsizeItem) {
			dispatch({type: 'CHECKOUT_OFFSIZE_ITEM'});
		}
		localStorage.setItem("item",JSON.stringify(chkItemArray));
	    localStorage.setItem("insurance",JSON.stringify(insurance));
	    localStorage.setItem("shipment_location_details",JSON.stringify(shipment_location_details));
	    localStorage.setItem("warehouse_id",JSON.stringify(warehouse_id));
      localStorage.setItem("airDangerous", JSON.stringify(airDangerous));
      localStorage.setItem("seaDangerous", JSON.stringify(seaDangerous));
      localStorage.setItem("totalValue", response.data.data.summary.usd.total_price)
		history.push('/checkout');
		}).catch((err) =>{
		dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: err,})
		dispatch({type: 'SC_PROTECT_UPDATED'});
		})
		}
}
export function checkOutPayAirAndSea (token, chkItemArray, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, shipment_location_details, warehouse_id, is_dangerous_air = 0, is_dangerous_sea = 0, scProtect, isOffsizeCheckoutItem){
	const payload = {
		token,
		"insurance":insurance,
		"payment_method": "credit_card",
		"payment_provider": payment_type === 'adyen' ? 'adyen-dropin':payment_type,
		"promo_code": promo_code,
		shipment_location_details,
		warehouse_id,
		is_dangerous_air,
		is_dangerous_sea,
		consent: {
			miniTnc: new Date(),
		}
	}

	if (chkItemArray.hasOwnProperty('air')) {
		payload.air = {
			items : chkItemArray.air,
			address : air_address,
			note: note_air,
		}
	}
	if (chkItemArray.hasOwnProperty('sea')) {
		payload.sea = {
			items : chkItemArray.sea,
			address: sea_address,
			note: note_sea,
		}
	}
	
	if (scProtect) {
		payload.sc_protect = scProtect;
	}

	if (isOffsizeCheckoutItem) {
		payload.consent.offsize = new Date();
	}

	return function(dispatch){
		dispatch({type: 'SC_PROTECT_UPDATING'});
		axios.post(apiUrl+'checkout/payment', payload)
		.then((response) => {
      localStorage.setItem("promoCode", promo_code)

			if(response.data.type === "other") {
        dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data})
				dispatch({type: 'SC_PROTECT_UPDATED'});
				dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
        history.push("/checkout-success?payment_type=other&Ref="+response.data.reference_id);

      } else if (payment_type === "adyen") {
				dispatch({type: 'SC_PROTECT_UPDATED'});
				dispatch({ type: 'CHECKOUT_ADYEN_FULFILLED', payload: response.data});

			} else if(payment_type === "paypal"){
				if(total_price === "0.00" || response.data.parameters.summary.php.total_price === "0"){
					dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,});
					dispatch({type: 'SC_PROTECT_UPDATED'});
					dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
					localStorage.setItem("checkout_response",response.data.parameters.payments.reference_id);
					history.push("/checkout-success");

				} else{
					localStorage.removeItem("checkout_response");
					window.location = response.data.parameters.payments.redirect;
					dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,})
					dispatch({type: 'SC_PROTECT_UPDATED'});

				}
			} else {
				dispatch({type: 'CHECKOUT_ASIAPAY_FULFILLED', payload: response.data,});
				dispatch({type: 'SC_PROTECT_UPDATED'});

				if(total_price === "0.00"){
					localStorage.setItem("checkout_response",response.data.parameters.payments.query.orderRef);
					dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
					history.push("/checkout-success");
				} else{
					localStorage.removeItem("checkout_response");
				}
			}
		}).catch((err) =>{
			dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: err,})
			dispatch({type: 'SC_PROTECT_UPDATED'});
			dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });

		})

	}

}
export function checkOutPayAir(token,chkItemArray,air_address,sea_address,insurance,payment_type,note_air,total_price,promo_code,shipment_location_details,warehouse_id,is_dangerous_air = 0, is_dangerous_sea = 0){

	let air = {};
	air = {
		items : chkItemArray.air,
		address : air_address,
		note: note_air
	}

	return function(dispatch){
		axios.post(apiUrl+'checkout/payment',
		{
			token,
			air,
			"insurance":insurance,
			"payment_method": "credit_card",
			"payment_provider": payment_type === 'adyen' ? 'adyen-dropin':payment_type,
      "promo_code": promo_code,
      shipment_location_details,
      warehouse_id,
      is_dangerous_air,
      is_dangerous_sea
		})
		.then((response) => {
      localStorage.setItem("promoCode", promo_code)
      if(response.data.type === "other") {
        dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data})
        history.push("/checkout-success?payment_type=other&Ref="+response.data.reference_id);

      } else if (payment_type === "adyen") {
          dispatch({ type: 'CHECKOUT_ADYEN_FULFILLED', payload: response.data});

      } else if(payment_type === "paypal"){
        if(total_price === "0.00" || response.data.parameters.summary.php.total_price === "0"){
          dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,});
          localStorage.setItem("checkout_response",response.data.parameters.payments.reference_id);
          history.push("/checkout-success");
        } else{
          localStorage.removeItem("checkout_response");
          window.location = response.data.parameters.payments.redirect;
          dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,})
        }

      } else {
        dispatch({type: 'CHECKOUT_ASIAPAY_FULFILLED', payload: response.data,});

        if(total_price === "0.00"){
          localStorage.setItem("checkout_response",response.data.parameters.payments.query.orderRef);
          history.push("/checkout-success");
        } else{
          localStorage.removeItem("checkout_response");
        }
      }

    }).catch((err) =>{
      dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: err,})
    })
	}
}
export function checkOutPaySea (token, chkItemArray, air_address, sea_address, insurance, payment_type, note_sea, total_price, promo_code, shipment_location_details, warehouse_id, is_dangerous_sea = 0, is_dangerous_air = 0){

	var sea = {};
	sea  = {
		items : chkItemArray.sea,
		address: sea_address,
		note: note_sea,
	}

	return function(dispatch){
		axios.post(apiUrl+'checkout/payment',
		{
			token,
			sea,
			"insurance":insurance,
			"payment_method": "credit_card",
			"payment_provider": payment_type === 'adyen' ? 'adyen-dropin':payment_type,
      "promo_code": promo_code,
      shipment_location_details,
      warehouse_id,
      is_dangerous_sea,
      is_dangerous_air
		})
		.then((response) => {
      localStorage.setItem("promoCode", promo_code)

      if(response.data.type === "other") {
        dispatch({ type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data})
        history.push("/checkout-success?payment_type=other&Ref="+response.data.reference_id);
      } else if (payment_type === "adyen") {
				dispatch({ type: 'CHECKOUT_ADYEN_FULFILLED', payload: response.data});

			} else if(payment_type === "paypal"){
				if(total_price === "0.00" || response.data.parameters.summary.php.total_price === "0"){
					dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,});
					localStorage.setItem("checkout_response",response.data.parameters.payments.reference_id);
					history.push("/checkout-success");

				} else{
					localStorage.removeItem("checkout_response");
					window.location = response.data.parameters.payments.redirect;
					dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,})

				}
			} else{
				dispatch({type: 'CHECKOUT_ASIAPAY_FULFILLED', payload: response.data,});

				if(total_price === "0.00"){
					localStorage.setItem("checkout_response",response.data.parameters.payments.query.orderRef);
					history.push("/checkout-success");

				} else{
					localStorage.removeItem("checkout_response");
				}
			}
		}).catch((err) =>{
			dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: err,})
		})
	}
}

export function checkOutAdyenDropin ({formData, checkoutDetails}){

	var air = {};
	var sea = {};

	air = {
		items : checkoutDetails.itemArry.air,
		address : checkoutDetails.air_address,
		note: checkoutDetails.note_air,
	}
	sea  = {
		items : checkoutDetails.itemArry.sea,
		address: checkoutDetails.sea_address,
		note: checkoutDetails.note_sea,
	}

	const adyenPayload = formData;
	if (formData.data && !formData.data.storePaymentMethod) {
		adyenPayload.data.storePaymentMethod = false;
	}

	const payload = {
		token: checkoutDetails.token,
		air,
		sea,
		"insurance":checkoutDetails.insurance,
		"payment_method": "credit_card",
		"payment_provider": 'adyen-dropin',
		"promo_code": checkoutDetails.promo_code,
		'shipment_location_details': checkoutDetails.shipment_location_details,
		'warehouse_id': checkoutDetails.warehouse_id,
		'is_dangerous_sea': checkoutDetails.is_dangerous_sea,
		'is_dangerous_air': checkoutDetails.is_dangerous_air,
		'adyen-payment-method': adyenPayload,
		data: formData.data,
		consent: checkoutDetails.consent
	}

	if (checkoutDetails.scProtect) {
		payload.sc_protect = checkoutDetails.scProtect;
	}

	return function(dispatch){
		return axios.post(apiUrl+'checkout/payment',payload)
		.then((res) => {
      localStorage.setItem("promoCode", checkoutDetails.promo_code)

			if (res.data.attributes.resultCode === 'RedirectShopper') {
				return res.data.attributes.action
			}
			dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
			history.push(`/checkout-success?payment_type=adyen&authResult=${res.data.attributes.resultCode.toUpperCase()}&merchantReference=${res.data.attributes.merchantReference}&pspReference=${res.data.attributes.pspReference}&shopperLocale=en_GB`)
		}).catch((err) =>{
			dispatch({type: 'SHOW_ERROR_ON_PAYMENT_MESSAGE',});
			dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
			history.push('/cart')
		})
	}
}
export function checkOutPayAirAndSeaPromo(token,chkItemArray,insurance,promo_code,payment_type,shipment_location_details,warehouse_id, scProtect){
	const payload = {
		token,
		"insurance":insurance,
		"payment_provider" : payment_type,
		"promo_code" : promo_code,
		shipment_location_details,
		warehouse_id
	}		
	if (scProtect) {
		payload.sc_protect = scProtect;
	}
	if (chkItemArray.hasOwnProperty("air")) {
		payload.air = {
			items : chkItemArray.air,
			address : chkItemArray.air.address,
			}
	}
	if (chkItemArray.hasOwnProperty("sea")) {
		payload.sea = {
			items : chkItemArray.sea,
			address : chkItemArray.sea.address,
			}
	}

	return function(dispatch){
		dispatch({type: 'PROMO_COMPUTED_PENDING',});
		dispatch({type: 'SC_PROTECT_UPDATING'});
		axios.post(apiUrl+'checkout/shipment', payload).then((response) => {
		dispatch({type: 'PROMO_COMPUTED_FULFILLED', payload: response.data,})
      localStorage.setItem("totalValue", response.data.data.summary.usd.total_price)
			dispatch({type: 'SC_PROTECT_UPDATED'});
		}).catch((err) =>{
		dispatch({type: 'PROMO_COMPUTED_REJECTED', payload: err,})
		dispatch({type: 'SC_PROTECT_UPDATED'});
		})
	}

}
export function checkOutPayAirPromo(token,chkItemArray,insurance,promo_code,payment_type,shipment_location_details,warehouse_id,scProtect){

var air = {};

	air = {
	items : chkItemArray.air,
	address : chkItemArray.air.address,

	}

	const payload = {
		token,
		air,
		"insurance":insurance,
		"payment_provider": payment_type,
		"promo_code" : promo_code,
		shipment_location_details,
		warehouse_id
		}
		if (scProtect) {
			payload.sc_protect = {avail: 1};
		}
	return function(dispatch){
		dispatch({type: 'PROMO_COMPUTED_PENDING',});
		axios.post(apiUrl+'checkout/shipment', payload).then((response) => {
		dispatch({type: 'PROMO_COMPUTED_FULFILLED', payload: response.data,})
      localStorage.setItem("totalValue", response.data.data.summary.usd.total_price)
		}).catch((err) =>{
		dispatch({type: 'PROMO_COMPUTED_REJECTED', payload: err,})
		})
	}
}
export function checkOutPaySeaPromo(token,chkItemArray,insurance,promo_code,payment_type,shipment_location_details,warehouse_id){

	var sea = {};
	sea  = {
	items : chkItemArray.sea,
	address : chkItemArray.sea.address,
	}
	return function(dispatch){
		dispatch({type: 'PROMO_COMPUTED_PENDING',});
		axios.post(apiUrl+'checkout/shipment', {
		token,
		sea,
		"insurance":insurance,
		"payment_provider" : payment_type,
		"promo_code" : promo_code,
		shipment_location_details,
		warehouse_id
		}).then((response) => {
		dispatch({type: 'PROMO_COMPUTED_FULFILLED', payload: response.data,})
      localStorage.setItem("totalValue", response.data.data.summary.usd.total_price)
		}).catch((err) =>{
		dispatch({type: 'PROMO_COMPUTED_REJECTED', payload: err,})
		})
	}
}


export function getCheckOut(token,chkItemArray,insurance,shipment_location_details,warehouse_id,scProtect, addressAir,addressSea){
	return function(dispatch){
		dispatch({type: 'SC_PROTECT_UPDATING'});
		const payload = {
			token,
			"air" : {
			"items" : chkItemArray.air,
			"address": addressAir,
			},
			"sea" :{
			"items" : chkItemArray.sea,
			"address": addressSea,
			},
			"insurance":insurance,
			shipment_location_details,
			warehouse_id
		}

		if (scProtect) {
			payload.sc_protect = scProtect;
		}

		axios.post(apiUrl+'checkout/shipment', payload).then((response) => {
			dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,});
			dispatch({type: 'RESET_INSURED_VALUE_ERROR', payload: response.data,});
			dispatch({type: 'SC_PROTECT_UPDATED'});
			localStorage.setItem("item",JSON.stringify(chkItemArray));
			localStorage.setItem("insurance",JSON.stringify(insurance));
			localStorage.setItem("shipment_location_details",JSON.stringify(shipment_location_details));
			localStorage.setItem("warehouse_id",JSON.stringify(warehouse_id));
      localStorage.setItem("totalValue", response.data.data.summary.usd.total_price)
		}).catch((err) =>{
		dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: err,})
		dispatch({type: 'SC_PROTECT_UPDATED'});
		})
	}
}

export function getCheck(token, chkItemArray, shipment_location_details, insurance, warehouse_id, willResetInsuredError,scProtect) {
	return async dispatch => {
		try {
      dispatch({ type: 'PARCEL_UPDATING' });
			dispatch({type: 'CHECKOUT_ITEM_REQUEST'})

			const payload = {
				token,
        "air": {
          "items": chkItemArray.air,
        },
        "sea": {
          "items": chkItemArray.sea,
        },
        shipment_location_details,
        insurance,
        warehouse_id,
			}
			if (scProtect) {
				payload.sc_protect = scProtect;
			}
			const response = await axios.post(apiUrl + 'shipments', payload)
			dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,})
      dispatch({ type: 'PARCEL_UPDATED' });
		} catch(err) {
			dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: err,})
      dispatch({ type: 'PARCEL_UPDATED' });
		}
		if (willResetInsuredError) {
			dispatch({type: 'RESET_INSURED_VALUE_ERROR', payload: null,});
      dispatch({ type: 'PARCEL_UPDATED' });
		}
 	}
    // return function (dispatch) {
	// 	dispatch({type: 'CHECKOUT_ITEM_REQUEST'})
    //     axios.post(apiUrl + 'shipments', {
    //         token,
    //         "air": {
    //             "items": chkItemArray.air,
    //         },
    //         "sea": {
    //             "items": chkItemArray.sea,
    //         },
    //         shipment_location_details,
    //         insurance,
    //         warehouse_id,
	// 	})
	// 	.then((response) => {
	// 		dispatch({type: 'CHECKOUT_ITEM_FULFILLED', payload: response.data,})
	// 	}).catch((err) => {
    //         dispatch({type: 'CHECKOUT_ITEM_REJECTED', payload: err,})
    //     });

    //     if (willResetInsuredError) {
    //         dispatch({type: 'RESET_INSURED_VALUE_ERROR', payload: null,});
    //     }
    // }
}

export function clearCheck(){
	return function(dispatch){
		dispatch({type: 'CLEAR_CHECKOUT_FULFILLED',});
		dispatch({type: 'REMOVE_INSURED_VALUE_ERROR_MESSAGE',});
		dispatch({type: 'RESET_UPDATE_ACCOUNTS'});
	}
}

export function resetComputed(){
	return function(dispatch){
		dispatch({type: 'RESET_COMPUTED',});
	}
}

export function clearPromoError() {
  return function(dispatch) {
    dispatch({type: 'CLEAR_PROMO_ERROR'})
  }
}

export function showEmptyItemOnCheckout(){
	return function(dispatch){
		dispatch({type: 'SHOW_EMPTY_CHECKOUT_MESSAGE',});
	}
}



export function setPayment(payment_provider,payment_status,reference_id,payer_id,psp_reference){
	return function(dispatch){
		dispatch({type: "PAYMENT_FETCHING"});
		axios.put(apiUrl+'checkout/payment-callback',
		{
			"payment_provider" : payment_provider,
			"payment_status" :payment_status ,
			"reference_id" : reference_id,
			"payer_id" : payer_id,
			"psp_reference": psp_reference,
		})
		.then((response) => {
			dispatch({type: 'PAYMENT_FULFILLED', payload: response.data,})
			if (payment_status==='canceled' || payment_status === 'CANCELLED') { // for cancelled transactions normal path
				dispatch({type: 'SHOW_CANCELLED_PAYMENT_MESSAGE',})
      	recordEvent('Cart', 'Cart', 'Checkout', 'Failed');
      } else if (payment_status === 'REFUSED') {
        dispatch({ type: 'SHOW_ERROR_ON_PAYMENT_MESSAGE', });
        recordEvent('Cart', 'Cart', 'Checkout', 'Failed');
      } else {
        recordEvent('Cart', 'Cart', 'Checkout', 'Success', 'USD', localStorage.totalValue, localStorage.promoCode);
        window.AF('pba', 'event', {eventType: 'EVENT', eventLabel: 'Success', eventCategory: 'Cart', eventRevenue: localStorage.totalValue, eventRevenueCurrency: 'USD', eventValue: '', eventName: 'Checkout' });
			}
		}).catch((err) =>{
      dispatch({type: 'PAYMENT_REJECTED', payload: err,})
      recordEvent('Cart', 'Cart', 'Checkout', 'Failed');
      if (err.response.data.errors.detail === "Transaction is not a valid for free shipping.") {
        dispatch({ type: 'SHOW_INVALID_TRANSACTION_ERROR'})
        history.push('/cart');
      } else if (payment_status!=='canceled') { // for cancelled transactions through paypal's return to merchant
        dispatch({type: 'SHOW_ERROR_ON_PAYMENT_MESSAGE',});
        history.push('/cart');
      }
		})
	}
}

export function setCheckoutDetails(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, shipment_location_details,warehouse_id ,is_dangerous_air,is_dangerous_sea,scProtect,isOffsizeCheckoutItem) {
	const consent = {
		miniTnc: new Date()
	}
	if (isOffsizeCheckoutItem) {
		consent.offsize = new Date();
	}
	return function(dispatch){dispatch({type: 'CHECKOUT_DETAILS',payload: {token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, shipment_location_details,warehouse_id ,is_dangerous_air,is_dangerous_sea,scProtect,consent}})};
}

export function resetOffsizeConsent() {
	return function (dispatch) {
    dispatch({ type: "CHECKOUT_OFFSIZE_ITEM_RESET" });
  };
}


/** WEBPACK FOOTER **
 ** ./src/actions/CheckoutActions.js
 **/